import { msg } from '@lingui/macro'

import courseImage from './images/collection_course.svg'
import contentImage from './images/content.svg'
import contentAudioImage from './images/content_audio.svg'
import contentEventOnlineEvent from './images/content_event_online_event.svg'
import contentEventPresenceEvent from './images/content_event_presence_event.svg'
import contentFreeText from './images/content_free_text.svg'
import contentImageImage from './images/content_image.svg'
import contentImageCarouselImage from './images/content_image_carousel.svg'
import contentSingleImage from './images/content_image_single_1.svg'
import contentLinkImage from './images/content_link.svg'
import contentPdfImage from './images/content_pdf.svg'
import contentQuizQuickQuizImage from './images/content_quiz_quick_quiz.svg'
import contentQuizSelfAssessmentTestImage from './images/content_quiz_self_assessment_test_1.svg'
import contentQuizVerificationTestImage from './images/content_quiz_verification_test_1.svg'
import contentVideoImage from './images/content_video.svg'
import eventImage from './images/event.svg'
import folderImage from './images/folder.svg'

export type SvgImport = { src: string }

export type CreateMenuItem = {
  title: string | { id: string }
  description?: string | { id: string }
  link?: string
  icon?: string | SvgImport
  items?: CreateMenuItem[]
}

export const CONTENT_TYPE_LINK: CreateMenuItem = {
  title: msg`Link`,
  link: '/contents/create',
  description: msg`Fai copia/incolla di un link, creeremo una card, facile da riconoscere, trovare e condividere.`,
  icon: contentLinkImage,
}

export const CONTENT_TYPE_PDF: CreateMenuItem = {
  title: msg`PDF`,
  link: '/contents/create?type=pdf',
  description: msg`Metti qui documenti e presentazioni per averli sempre a tua disposizione e inserirli in raccolte e corsi.`,
  icon: contentPdfImage,
}

export const CONTENT_TYPE_VIDEO: CreateMenuItem = {
  title: msg`Video`,
  link: '/contents/create?type=video',
  description: msg`Carica qui i tuoi video e utilizzali per creare raccolte e corsi online.`,
  icon: contentVideoImage,
}

export const CONTENT_TYPE_AUDIO: CreateMenuItem = {
  title: 'Audio',
  link: '/contents/create?type=audio',
  description:
    'Racconta le tue storie attraverso contenuti audio e crea esperienze formative coinvolgenti.',
  icon: contentAudioImage,
}

export const CONTENT_TYPE_IMAGE_SINGLE: CreateMenuItem = {
  title: 'Immagine',
  link: '/contents/create?type=image',
  description:
    "Racconta qualcosa con una foto, un'infografica, una mappa mentale o un'immagine.",
  icon: contentSingleImage,
}

export const CONTENT_TYPE_IMAGE_CAROUSEL: CreateMenuItem = {
  title: 'Carosello',
  link: '/contents/create?type=carousel',
  description:
    "Carica due o più immagini per creare una sequenza di elementi collegati l'uno all'altro.",
  icon: contentImageCarouselImage,
}

export const CONTENT_TYPE_IMAGE: CreateMenuItem = {
  title: 'Gallery',
  description:
    'Carica infografiche, schemi, slide o qualsiasi altra immagine utile per le tue iniziative.',
  icon: contentImageImage,
  items: [CONTENT_TYPE_IMAGE_SINGLE, CONTENT_TYPE_IMAGE_CAROUSEL],
}

export const CONTENT_TYPE_QUIZ_QUICK_QUIZ: CreateMenuItem = {
  title: 'Quiz rapido',
  link: '/contents/create?type=quick_quiz',
  description:
    'Coinvolgi e aiuta i tuoi studenti a verificare il loro livello di apprendimento nei tuoi corsi.',
  icon: contentQuizQuickQuizImage,
}

export const CONTENT_TYPE_QUIZ_SELF_ASSESSMENT_TEST: CreateMenuItem = {
  title: 'Test di autovalutazione',
  link: '/contents/create?type=self_assessment_test',
  description:
    'Aiuta i tuoi studenti a verificare il loro livello di apprendimento tramite un semplice test.',
  icon: contentQuizSelfAssessmentTestImage,
}

export const CONTENT_TYPE_QUIZ_VERIFICATION_TEST: CreateMenuItem = {
  title: 'Test di verifica',
  link: '/contents/create?type=verification_test',
  description: 'Verifica il livello di apprendimento dei tuoi studenti.',
  icon: contentQuizVerificationTestImage,
}

export const CONTENT_TYPE_QUIZ: CreateMenuItem = {
  title: 'Quiz',
  description:
    'Coinvolgi e aiuta i tuoi studenti a verificare il loro livello di apprendimento nei tuoi corsi.',
  icon: contentQuizQuickQuizImage,
  items: [
    CONTENT_TYPE_QUIZ_QUICK_QUIZ,
    CONTENT_TYPE_QUIZ_SELF_ASSESSMENT_TEST,
    CONTENT_TYPE_QUIZ_VERIFICATION_TEST,
  ],
}

export const CONTENT_TYPE_EVENT_ONLINE_EVENT: CreateMenuItem = {
  title: 'Evento online',
  link: '/contents/create?type=online_event',
  description:
    'Crea un evento live online per presentare il tuo catalogo formativo ai tuoi potenziali clienti e mostra dal vivo alcuni dei tuoi percorsi.',
  icon: contentEventOnlineEvent,
}

export const CONTENT_TYPE_EVENT_ZOOM_EVENT: CreateMenuItem = {
  title: 'Evento Zoom',
  link: '/contents/create?type=zoom_event',
  description: 'Crea evento Zoom.',
  icon: contentQuizSelfAssessmentTestImage,
}

export const CONTENT_TYPE_EVENT_PRESENCE_EVENT: CreateMenuItem = {
  title: 'Evento in presenza',
  link: '/contents/create?type=presence_event',
  description:
    'Definisci la data del tuo evento e ottieni un link da condividere sui tutti i tuoi canali per promuoverlo a quante più persone.',
  icon: contentEventPresenceEvent,
}

export const CONTENT_TYPE_EVENT: CreateMenuItem = {
  title: 'Evento',
  description:
    'Organizza il tuo prossimo webinar, la tua prossima lezione online o il tuo prossimo evento formativo in presenza.',
  icon: eventImage,
  items: [CONTENT_TYPE_EVENT_ONLINE_EVENT, CONTENT_TYPE_EVENT_PRESENCE_EVENT],
}

export const CONTENT_TYPE_TEXT: CreateMenuItem = {
  title: msg`Testo`,
  link: '/contents/create?type=text',
  description: msg`Crea articoli e contenuti testuali formativi da poter utilizzare nei tuoi corsi.`,
  icon: contentFreeText,
}

export const CONTENT_TYPE_FOLDER: CreateMenuItem = {
  title: msg`Cartella`,
  link: '/folders/create',
  description: msg`Riordina e raggruppa i tuoi contenuti come preferisci in cartelle personali.`,
  icon: folderImage,
  items: [],
}

export const COLLECTION_TYPE_COURSE: CreateMenuItem = {
  title: msg`Raccolta/Corso`,
  link: '/collections/create',
  description: msg`Aggrega i tuoi contenuti e crea raccolte e corsi da condividere privatamente o vendere online.`,
  icon: courseImage,
  items: [],
}

export const CONTENT_TYPES: CreateMenuItem[] = [
  CONTENT_TYPE_LINK,
  CONTENT_TYPE_PDF,
  CONTENT_TYPE_VIDEO,
  CONTENT_TYPE_TEXT,
]

export const OLD_FEATURES_CONTENT_TYPES: CreateMenuItem[] = [
  CONTENT_TYPE_LINK,
  CONTENT_TYPE_PDF,
  CONTENT_TYPE_VIDEO,
  CONTENT_TYPE_AUDIO,
  CONTENT_TYPE_QUIZ,
  CONTENT_TYPE_TEXT,
]

export const CREATE_MENU_DEFAULT_OPTIONS = (
  canUseFeatsBefore20240801: boolean,
  isCreatingInsideFolder: boolean
): CreateMenuItem[] => [
  {
    title: msg`Contenuto`,
    description: msg`Carica i tuoi contenuti digitali e ottieni, per ognuno, una card pronta per essere condivisa.`,
    icon: contentImage,
    items: canUseFeatsBefore20240801
      ? OLD_FEATURES_CONTENT_TYPES
      : CONTENT_TYPES,
  },
  ...(!isCreatingInsideFolder ? [CONTENT_TYPE_FOLDER] : []),
  COLLECTION_TYPE_COURSE,
]
